/**
 * PairRankingTable — the two rankings of redundancy, side by side but never
 * mixed: portfolio points (Portfolio Impact) and structural similarity.
 *
 * Each row opens the Phase 2 drill-down for that pair.
 */
const pct = (value, digits = 1) =>
  value === null || value === undefined ? "n/d" : `${Number(value).toFixed(digits)}%`;
const pp = (value, digits = 2) =>
  value === null || value === undefined ? "n/d" : `${Number(value).toFixed(digits)} pp`;

const RELIABILITY_LABEL = {
  high: "alta", usable: "media", insufficient: "insufficiente", no_data: "nessun dato",
};

export function PairRankingTable({ pairs, mode, onSelectPair }) {
  if (!pairs.length) return null;
  return (
    <div className="overflow-x-auto rounded-lg border border-line">
      <table className="w-full text-label" data-testid={`pair-ranking-${mode}`}>
        <caption className="sr-only">
          {mode === "impact"
            ? "Coppie di ETF ordinate per duplicazione in punti di portafoglio"
            : "Coppie di ETF ordinate per sovrapposizione strutturale"}
        </caption>
        <thead>
          <tr className="bg-surface-subtle text-content-muted">
            <th scope="col" className="px-3 py-2 text-left font-medium">Coppia</th>
            <th scope="col" className="px-3 py-2 text-right font-medium">Pesi</th>
            <th scope="col" className="px-3 py-2 text-right font-medium">
              {mode === "impact" ? "Duplicazione" : "Strutturale"}
            </th>
            <th scope="col" className="px-3 py-2 text-right font-medium">
              {mode === "impact" ? "Strutturale" : "Duplicazione"}
            </th>
            <th scope="col" className="px-3 py-2 text-right font-medium">Affidabilità</th>
            <th scope="col" className="px-3 py-2 text-right font-medium">Dettaglio</th>
          </tr>
        </thead>
        <tbody>
          {pairs.map((pair) => {
            const impact = (
              <span className="tabular">
                {pp(pair.overlapping_mass_pct)}
                <span className="block text-content-muted">
                  max {pp(pair.overlapping_mass_max_pct)}
                </span>
              </span>
            );
            const structural = (
              <span className="tabular">
                {pair.structural_overlap_pct == null ? "n/d" : pct(pair.structural_overlap_pct)}
              </span>
            );
            return (
              <tr
                key={`${pair.a}|${pair.b}`}
                className="border-t border-line"
                data-testid={`pair-row-${pair.a}-${pair.b}`}
              >
                <td className="px-3 py-2 font-mono text-content">{pair.a} · {pair.b}</td>
                <td className="px-3 py-2 text-right tabular text-content-muted">
                  {pct(pair.weight_a_pct, 1)} / {pct(pair.weight_b_pct, 1)}
                </td>
                <td className="px-3 py-2 text-right font-medium text-content">
                  {mode === "impact" ? impact : structural}
                </td>
                <td className="px-3 py-2 text-right text-content-secondary">
                  {mode === "impact" ? structural : impact}
                </td>
                <td className="px-3 py-2 text-right text-content-muted">
                  {RELIABILITY_LABEL[pair.reliability] || pair.reliability}
                </td>
                <td className="px-3 py-2 text-right">
                  <button
                    type="button"
                    data-testid={`pair-open-${pair.a}-${pair.b}`}
                    onClick={() => onSelectPair({ a: pair.a, b: pair.b })}
                    aria-label={`Apri il dettaglio di ${pair.a} e ${pair.b}`}
                    className="min-h-10 px-3 rounded-md border border-line text-content
                               transition-colors hover:bg-surface-subtle
                               focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-focus"
                  >
                    Apri
                  </button>
                </td>
              </tr>
            );
          })}
        </tbody>
      </table>
    </div>
  );
}

export default PairRankingTable;
